export enum PaymentSourceEnum {
  'invoicing' = 'invoicing',
  'giftcard' = 'giftcard',
  'webordering' = 'webordering',
  'deposit' = 'deposit',
}
